// extracted by mini-css-extract-plugin
export default {"container":"Products_container__72HUN","container_staff":"Products_container_staff__FYC2Q","products":"Products_products__2VUqj","loading":"Products_loading__pFzZo"};